import { UseApi } from '../utils/axios-pettitions';

export async function getProductosDeCliente(clienteId: number) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('clientes/productos', 'GET', { clienteId });
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al obtener los productos del cliente',
    };
  }
}

export async function asignarProductoACliente(data: { ClPr_Cl_Id: number; ClPr_Pr_Id: number }) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('clientes/productos', 'POST', null, data);
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al asignar el producto al cliente',
    };
  }
}

export async function quitarProductoDeCliente(detalleId: number) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('clientes/productos', 'DELETE', { detalleId });
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al quitar el producto del cliente',
    };
  }
}
